export { AppText } from "./AppText";
export { useAppText } from "./useAppText";
